import type { DriveStep } from 'driver.js';

export const customerOrdersTourId = 'customer:orders';

export const customerOrdersSteps: DriveStep[] = [
  {
    element: '[data-tour="customer:header"]',
    popover: {
      title: 'Добро пожаловать!',
      description:
        'Добро пожаловать в AFlow! Здесь вы можете отслеживать свои заказы, получать уведомления и управлять профилем.',
    },
  },
  {
    element: '[data-tour="customer:nav-orders"]',
    popover: {
      title: 'Заказы',
      description:
        'Раздел "Заказы" — здесь все ваши заказы. Используйте вкладки для фильтрации: все, активные или завершённые.',
    },
  },
  {
    element: '[data-tour="customer:orders-tabs"]',
    popover: {
      title: 'Вкладки',
      description:
        'Вкладки для быстрой навигации: "Все" покажет все заказы, "Активные" — только текущие, "Завершённые" — уже полученные.',
    },
  },
  {
    element: '[data-tour="customer:orders-list"]',
    popover: {
      title: 'Список заказов',
      description:
        'Список ваших заказов. Нажмите на заказ, чтобы увидеть детали, статус и QR-код для получения.',
    },
  },
  {
    element: '[data-tour="customer:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Кнопка помощи — нажмите, чтобы увидеть обучение заново.',
    },
  },
];
